<template>
    <div class="shen">
        <main>
            <van-icon name="passed" />
            <h2>注册成功，正在审核</h2>
            <van-button type="danger" style="width:80%" @click="go()">返回登录</van-button>
        </main>
    </div>
</template>

<script>

export default {
    data() {
        return {
           
        }
    },

    
    mounted() {
       
    },
    methods: {
        go() {
            this.$router.push('./sign')
        }
    }
};
</script>
<style lang="less" scoped>
    .shen {
        main {
            margin-top: 100px;
            text-align: center;
            i {
                font-size: 100px;
                color: #EE0A24;
            }
        }
        h2 {
            margin: 40px 0;
        }
    }
    
</style>
